import actions from './actions';
import mutations from './mutations';
import getters from './getters';

const state = {
  orderDetails: {
    loading: false,
    errorMessage: '',
    successMessage: '',
    order: {
      items: [],
    },
    clientSettings: {},
    customerInfo: {},
  },
  addressDetails: {
    loading: false,
    errorMessage: '',
    successMessage: '',
    customer: {},
    items: [],
    policies: [],
    orderNumber: '',
    symbol: '',
    requiresPayment: false,
    underwriter: {},
    data: {},
  },
  recharge: {
    loading: false,
    errorMessage: '',
    successMessage: '',
    id: '',
  },
  openEndedDetails: {
    loading: false,
    errorMessage: '',
    successMessage: '',
    data: {},
  },
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
